import { Box, Stack, useTheme } from '@mui/material';
import useResponsive from '@/hooks/useResponsive';
import Typography from '@/components/Typography';
import Image from 'next/image';
import { useRouter } from 'next/router';
import getLocalFile from '@/utils/getLocalFile';

const Hero = () => {
  const { matches } = useResponsive();
  const theme = useTheme();

  const {
    query: { symbol }
  } = useRouter();

  const marketName = symbol?.toString().toUpperCase() || '';
  const data = getLocalFile(marketName, 'info');

  return (
    <>
      <Stack
        direction={matches({ lg: 'row', xs: 'column' })}
        justifyContent="center"
        alignItems="center"
        spacing={matches({ lg: 9, xs: 4 })}
        flex="50%"
      >
        <Stack spacing={3} flex={matches({ lg: '50%', xs: 0 })}>
          <Typography
            weight="bold"
            component="h1"
            variant={matches({ xs: 'subtitle', lg: 'h3' })}
            textAlign={matches({ xs: 'center', lg: 'initial' })}
            sx={{ pt: matches({ lg: 0, xs: 7 }) }}
            color={theme.palette.textColor.A80}
          >
            {data?.HeroSection?.header}
          </Typography>
          <Typography
            variant={matches({ lg: 'h6', xs: 'body2' })}
            textAlign={matches({ xs: 'center', lg: 'initial' })}
            dangerouslySetInnerHTML={{
              __html: data?.HeroSection?.description || ''
            }}
            component="div"
            weight="bold"
            color={theme.palette.textColor.A60}
          />
        </Stack>
        <Box
          sx={{
            width: '100%',
            maxWidth: 605,
            height: 'auto'
          }}
        >
          <Image
            src={data?.HeroSection?.image}
            alt="scam"
            priority
            width={605}
            height={476}
            style={{
              width: '100%',
              height: 'auto'
            }}
          />
        </Box>
      </Stack>
    </>
  );
};

export default Hero;
